import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch8_p01 } from "../../../layouts/ch8_p01/ch8_p01";

export class Chapter8Page1 extends AbstractStoryState implements ReturnType<typeof ch8_p01> {
    readonly bg = this.addChild(new SceneSprite());
    readonly textbg = this.addChild(new SceneSprite());
    readonly textContainer = this.addChild(new PIXI.Container());
    readonly letters = list(()=>this.textContainer.addChild(new SceneSprite()));
    readonly sheepContainer = this.addChild(new PIXI.Container());
    readonly sheep = list(()=>this.sheepContainer.addChild(new SceneSprite()));
    readonly pen = this.addChild(new SceneSprite());
    readonly grass = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch8_p01/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch8_p01/"));

    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch8_p01/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch8_p01/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch8_p01.call(this);

        const lettersTimeline = new TimelineMax();
        lettersTimeline.staggerFrom(this.letters, 0.5, {pixi: {
            alpha: 0,
            scale: 0.4,
        }}, 0.1);
        lettersTimeline.repeat(-1).repeatDelay(0.5);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(3, ()=>{
            this.gotoNextState({transition: "up"});
        });
    }
}